import React from 'react';
import { PLACEHOLDER_SCREENS } from './phaseData';

/**
 * PlaceholderScreen — premium "coming soon" for the 9 destinations
 * that will be built in later phases (Body Snapshot, Symptoms, etc.).
 *
 * These are NOT dead buttons — they are real, navigable screens with
 * consistent chrome and design language, so the app already feels
 * whole. Each placeholder previews the eventual content in one line.
 */
export default function PlaceholderScreen({ screenId, onBack }) {
  const data = PLACEHOLDER_SCREENS[screenId] || {
    title: 'Coming Soon', eyebrow: '', body: '',
  };

  return (
    <div className="cx-subscreen" data-testid={`screen-${screenId}`}>
      <header className="cx-sub-hd">
        <button className="cx-back-btn" onClick={onBack} aria-label="Back" data-testid="subscreen-back">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
            <path d="m15 6-6 6 6 6"/>
          </svg>
        </button>
        <div className="cx-sub-title">
          <span className="cx-sub-eyebrow">{data.eyebrow}</span>
          {data.title}
        </div>
      </header>

      <div className="cx-sub-body">
        <div className="cx-placeholder-empty">
          <div className="cx-placeholder-mark" aria-hidden="true"/>
          <div className="cx-placeholder-eyebrow">Coming soon</div>
          <div className="cx-placeholder-title">{data.title}</div>
          <p className="cx-placeholder-body">{data.body}</p>
        </div>
      </div>
    </div>
  );
}
